import React, {useState} from 'react';

import { Select, MenuItem } from '@mui/material';

const SelectOptionForSEPApplication = ({setApplicationSettingType}:{setApplicationSettingType?:any;}) => {
  const [value, setValue] = useState('Quick Help Menu')
  return (
    <Select
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={value}
      size="small"
      onChange={(e) => {
        setValue(e.target.value)
        setApplicationSettingType(e.target.value)}}
      sx={{ maxWidth: '250px' }}
    >
      <MenuItem value={'Quick Help Menu'}>Quick Help Menu</MenuItem>
      <MenuItem value={'Sep Settings'}>SEP Settings</MenuItem>
      <MenuItem value={'SEP Banner'}>SEP Banner</MenuItem>
    </Select>
  );
};

export default SelectOptionForSEPApplication;
